"use client";
import { motion, useReducedMotion } from "framer-motion";
import React from "react";
export function FadeUp(param) {
    var yGap = param.yGap, children = param.children, className = param.className;
    var reducedMotion = useReducedMotion();
    return /*#__PURE__*/ React.createElement(motion.div, {
        className: className,
        transition: {
            duration: 0.8
        },
        initial: {
            opacity: reducedMotion ? 1 : 0,
            y: reducedMotion ? 0 : yGap
        },
        whileInView: {
            opacity: 1,
            y: 0
        }
    }, children);
}
